import React from 'react';

import CustomSelect from '@/components/Dashboard/inbound/components/CustomSelect';
import { FONT_OPTIONS, FONT_SIZES } from '@/components/Dashboard/Lists/components/ContractsBox/constants';
import SixDots from '@/components/Icons/icons/SixDots';
import TickIcon from '@/components/Icons/icons/TickIcon';
import FieldsSidebarSkeleton from '@/components/Skeletons/FieldsSidebarSkeleton';

// Custom render option for font family to show the font preview
const renderFontOption = ({ option, onChange, value, setShowDropdown }) => {
  const isActive = option.value === value;
  return (
    <div
      className="menuItem custom-select-menuItem"
      style={{
        backgroundColor: isActive ? 'var(--purple-p-10)' : '',
        color: isActive ? 'var(--purple-p-400)' : '',
        fontFamily: option.label,
      }}
      onClick={() => {
        onChange(option.value, option.label);
        setShowDropdown(null);
      }}>
      <div>{option.label}</div>
      {isActive && (
        <div>
          <TickIcon width={20} height={30} color="var(--purple-p-400)" />
        </div>
      )}
    </div>
  );
};

const DraggableField = ({ field }) => {
  const handleDragStart = (e) => {
    const fieldRect = e.currentTarget.getBoundingClientRect();
    // Calculate offset from the field's top-left corner to the mouse position
    const offsetX = e.clientX - fieldRect.left;
    const offsetY = e.clientY - fieldRect.top;

    const dragData = {
      ...field,
      templateId: field.id,
      id: crypto.randomUUID(),
      icon: field.iconKey,
      isRequired: field.isRequired,
      dragOffset: { x: offsetX, y: offsetY }, // Include the offset in drag data
    };
    e.dataTransfer.setData('field', JSON.stringify(dragData));
    e.dataTransfer.effectAllowed = 'copy';
  };

  return (
    <div draggable onDragStart={handleDragStart} className="draggable-field">
      <span className="draggable-field-left-border"></span>
      <SixDots />
      <div className="draggable-field-content">
        <span className="field-icon">{field.icon}</span>
        <span className="field-label">{field.label}</span>
      </div>
    </div>
  );
};

const FieldSection = ({ title, fields, isRequired }) => {
  if (!fields.length) return null;

  return (
    <div className="field-section">
      <h3>
        {title}
        {isRequired && <span className="required-fields-indicator">*</span>}
      </h3>
      <div className="fields-list">
        {fields.map((field) => (
          <DraggableField key={field.id} field={field} />
        ))}
      </div>
    </div>
  );
};

const FieldsSidebar = ({ fields, isLoading, fontFamily, fontSize, onFontChange }) => {
  if (isLoading) {
    return <FieldsSidebarSkeleton />;
  }

  return (
    <div className="fields-sidebar">
      <FieldSection title="DYNAMIC FIELDS" fields={fields.dynamic} />
      <div className="field-formatting-section">
        <h3>TEXT FORMATTING</h3>
        <CustomSelect
          value={fontFamily}
          onChange={(value) => onFontChange('fontFamily', value)}
          options={FONT_OPTIONS}
          placeholderText="Select font"
          renderOption={renderFontOption}
          selectedStyle={{ fontFamily }}
        />
        <CustomSelect
          value={fontSize}
          onChange={(value) => onFontChange('fontSize', value)}
          options={FONT_SIZES}
          placeholderText="Select size"
        />
      </div>
      <FieldSection title="SIGNATURE" fields={fields.signature} isRequired />
    </div>
  );
};

export default FieldsSidebar;
